import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=f1cf1970&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=f1cf1970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf1970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
